<template>
  <AppContainer>
    <div class="home"/>
  </AppContainer>
</template>

<script>
export default {
  components: {
  },
};
</script>
